import { eventEmitter } from '../../decorators'
import { EventEmitterInterface } from '../../utils/EventEmitter'
import Service /* , { ServiceConfig } */ from '../Service'
import Database from './Database'
// export interface ClientConfig extends ServiceConfig {}

@eventEmitter
export default class PGManager extends Service
  implements EventEmitterInterface {
  private _databases?: Database[]

  // constructor(config: ServiceConfig) {
  //   super(config)
  // }

  // EventEmitter interface implementation
  on(event: string, listener: (...args: any[]) => void): void {
    return
  }
  removeListener(event: string, listener: (...args: any[]) => void): void {
    return
  }
  emit(event: string, ...args: any[]): void {
    return
  }
  once(event: string, listener: (...args: any[]) => void): void {
    return
  }

  get databases(): Database[] | void {
    return this._databases
  }

  // api
  database(dbId: string): Database {
    return new Database(this.app, dbId)
  }

  sync(): Promise<this> {
    return this.app
      .client()
      .pgManager.getDatabases()
      .then((response) => {
        this._databases = response.databases.map(
          (info) => new Database(this.app, info.name, info)
        )

        return this
      })
  }
}
